// extracted by mini-css-extract-plugin
module.exports = {"icon":"hXRUiWRoZiiY","flights":"_17uCqAwnHydT","flight":"_3KRxpyR6PV53"};